import { configureStore, createSlice } from "@reduxjs/toolkit";

/* =========================
   🔐 AUTH SLICE
========================= */

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,     // { id, name, groups: [] }
    token: null,
    isAuthenticated: false
  },
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      state.isAuthenticated = true;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
    }
  }
});

/* =========================
   🏪 STORE
========================= */

const store = configureStore({
  reducer: {
    auth: authSlice.reducer
  }
});

/* =========================
   🚀 EXPORTS
========================= */

export const { setUser, setToken, logout } = authSlice.actions;

export default store;